query Currencies {
currencies(orderBy: NAME_ASC) {
  nodes {
      id
      name
      isoCode
    }
  }
}
